import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'batp-footerstripe',
  templateUrl: './footerstripe.component.html',
  styleUrls: ['./footerstripe.component.css']
})
export class FooterstripeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
